import PropTypes from 'prop-types';
import clsx from 'clsx';
import Form from '@assets/icons/form.svg';
import CustomCheckbox from '@components/shared/CustomCheckbox';
import CustomButton from '@components/shared/CustomButton';
import { SIGNATURE_TYPE } from '@features/DocViewer/Steps/Docs/constants';
import { formatDocViewerDate } from '@shared/helpers/format';
import DownloadIcon from '@assets/icons/download.svg';
import ThreeDotsDropdown from '@components/ThreeDotsDropdown';
import CustomText from '@components/shared/CustomText';
import signatureId from '@shared/helpers/signatureId';
import styles from './DesktopRow.module.scss';

const DesktopRow = ({
  item,
  rowCheckbox,
  onDownload,
  handleItemClick,
  dropdownItems,
  isSelected,
  onSelect,
}) => {
  return (
    <tr
      key={signatureId(item)}
      className={styles.row}
      onClick={() => onSelect(rowCheckbox)}
    >
      <td>
        <span className={clsx(styles.flex, styles.formName)}>
          <CustomCheckbox checked={isSelected} readOnly small />
          <div className={styles.flex}>
            <Form />
          </div>
          <CustomText customStyle={clsx('body1', 'ellipsis')}>
            {item?.form_name}
          </CustomText>
        </span>
      </td>
      <td className='subtitle1'>{formatDocViewerDate(new Date(item?.date))}</td>
      <td className='subtitle1'>{SIGNATURE_TYPE[item?.signature_type]}</td>
      <td>
        <span className={styles.downloadColumn}>
          <CustomButton
            onClick={onDownload}
            small
            secondary
            maxWidth={110}
            text={'Download'}
            icon={<DownloadIcon width={14} />}
          />
          <ThreeDotsDropdown items={dropdownItems} onSelect={handleItemClick} />
        </span>
      </td>
    </tr>
  );
};

DesktopRow.propTypes = {
  item: PropTypes.shape({
    user_id: PropTypes.string,
    date: PropTypes.string,
    form_name: PropTypes.string,
    signature_type: PropTypes.string,
    signed_doc_url: PropTypes.string,
  }),
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  rowCheckbox: PropTypes.string,
  onDownload: PropTypes.func,
  handleItemClick: PropTypes.func,
  dropdownItems: PropTypes.array,
};

export default DesktopRow;
